import React, { useState, useEffect } from "react";
import { Mail, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FloatingContactButtonProps {
  contactSectionId?: string;
}

const FloatingContactButton: React.FC<FloatingContactButtonProps> = ({
  contactSectionId = "contact", // Default ID of your contact section
}) => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling down a bit
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 300px
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById(contactSectionId);
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!isVisible) return null;

  return (
    <Button
      onClick={scrollToContact}
      className="fixed bottom-20 right-4 z-40 h-12 w-12 rounded-full shadow-lg bg-primary hover:bg-primary/90 text-white"
      aria-label="Contact me"
    >
      <Mail className="h-5 w-5" />
    </Button>
  );
};

export default FloatingContactButton;
